import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import CommunityTopicsManager from 'apps/home/community/topics/appManager';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { SectionBanner, Paragraph, Box } from 'components';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { TopicCard } from 'legacyComponents/cards/types/topic';
import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';

import TagsList from './TagsList';
// import TopicsList from './TopicsList';

@withNamespaces()
@inject('routerStore')
@observer
export default class CommunityTopics extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new CommunityTopicsManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const connection = this.appManager.channelsConn;
    const topics = connection.arrayApp;
    return (
      <>
        <Header />

        <MainWrapper>
          <SectionBanner
            bannerId='how-do-topics-work'
            imageSrc='/assets/banners/004.svg'
            title='Dive into your interests.'
            buttonText='Learn More'
            linkName='https://help.wikifactory.com/en/articles/4616260-tags-and-topic-pages'
            paddingTop='xlarge'
            paddingBottom='xxlarge'
            eventCallback={() =>
              analytics.sendEvent(BANNER_ACTIONS.COMMUNITY_TOPICS)
            }
          >
            <Box>
              <Paragraph>
                On Wikifactory, all public content can be{' '}
                <strong>tagged with Topics</strong>.
              </Paragraph>
              <Paragraph>
                Each Topic has a page that{' '}
                <strong>
                  aggregates Projects, Stories, Threads and Collections
                </strong>{' '}
                for easy discovery.
              </Paragraph>
              <Paragraph>
                Discover content on Wikifactory in the{' '}
                <strong>Topics of your interest</strong>.
              </Paragraph>
            </Box>
          </SectionBanner>
          <TagsList />
          <CardSection
            invisible={this.appManager.loading}
            title={t('All Topics')}
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={topics}
            CardComponent={TopicCard}
            noDataCardType='topic'
            gridColumns={4}
            gridGap='default'
          />
        </MainWrapper>
      </>
    );
  }
}

CommunityTopics.propTypes = {
  t: PropTypes.func,
};
